import { Button } from "@material-tailwind/react";
import { useState } from "react";
import ModalLayout from "../components/Reuseable/modal/ModalLayout";

const SelectProjectModal = ({ setShowModal }) => {
  const [selectedValue, setSelectedValue] = useState("");
  const handleProject = (value) => {
    if (value == "ecoMetrix") {
      localStorage.setItem("unitName", JSON.stringify("EGMCL Unit-7"));
      localStorage.setItem("unitId", JSON.stringify(109));
      setSelectedValue(value);
      console.log("Selected Project:", value);
      localStorage.setItem("selectedProject", value);
      window.location.href = "/";
    } else {
      setSelectedValue(value);
      console.log("Selected Project:", value);
      localStorage.setItem("selectedProject", value);
      window.location.href = "/";
    }
  };

  return (
    <div>
      <ModalLayout modalTitle={"Select Project"} className="bg-blue-gray-400">
        <div className=" grid grid-cols-1 md:grid-cols-3 gap-2">
          <Button
            className="text-lg text-black bg-[#fbe89c] py-7 px-6"
            onClick={() => handleProject("machineStatus")}
          >
            Machine Status
          </Button>

          <Button
            className="text-lg text-white bg-[#2b8d26] py-7 px-6"
            onClick={() => handleProject("ecoMetrix")}
          >
            ECO Metrix
          </Button>

          <Button className="text-lg text-white bg-[#d24242] cursor-not-allowed py-7 px-6">
            Fire
          </Button>
        </div>
      </ModalLayout>
    </div>
  );
};

export default SelectProjectModal;
